import { CopyButton } from '@/components/ui/CopyButton'
import { cn } from '@/lib/utils'

/** A copyable code reference — a service, an action class, a component name. */
export function MonoRef({ value, className }: { value: string; className?: string }) {
  return (
    <span className={cn('text-ink-400 inline-flex items-center gap-0.5 font-mono text-[10px]', className)}>
      {value}
      <CopyButton
        value={value}
        className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
      />
    </span>
  )
}
